// extracted by mini-css-extract-plugin
module.exports = {"linkUnderline":"styles-module--linkUnderline--2IQ2X","w500":"styles-module--w500--1wz_h"};